import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DataManager } from '@syncfusion/ej2-data';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ThirdPartyUserAssignmentEditZonesSelectorService } from './third-party-user-assignment-edit-zones-selector.service';
import { GridModule } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'app-third-party-user-assignment-edit-zones-selector',
  templateUrl: './third-party-user-assignment-edit-zones-selector.component.html',
  styleUrls: ['./third-party-user-assignment-edit-zones-selector.component.scss'],
  imports: [GridModule, TranslateModule],
  providers: [ThirdPartyUserAssignmentEditZonesSelectorService]
})
export class ThirdPartyUserAssignmentEditZonesSelectorComponent extends GridBaseComponent implements OnInit {

  @Input() public set clientId (value: number) {
    if(this.service.clientId !== value) {
      this.service.clientId = value;
      this.grid?.refresh();
    }
  }

  public get zonePathFieldName(): string {
    return this.service.extendedZonePathFieldName;
  }

  constructor(translateService: TranslateService, private service: ThirdPartyUserAssignmentEditZonesSelectorService, private spinnerService: SpinnerService) {
    super(null, translateService, service);
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.service, this.spinnerService),
    });
  }

  public getSelectedZoneIds(): number[] {
    return this.grid.getSelectedRecords().map((record: any) => record.id);
  }

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected override getEditDialogTitleParams(rowData: any) {
    throw new Error('Method not implemented.');
  }

}


